import * as NeighborhoodsActions from './neighborhood.actions';

import {createEntityAdapter, EntityAdapter} from "@ngrx/entity";
import {createReducer, on} from "@ngrx/store";
import {TenNeighborhood, TenNeighborhoodSearchParams} from "../../_models/neighborhood.models";
import {StoredComponentHelperService} from '@common/helpers/stored-component.helper.service';
import {EntityStateModel} from '@common/models/entity-state.models';
import {SetAllInitialStates} from '@common/store/actions/core.actions';

export const neighborhoodsFeatureKey = 'neighborhoods';

export const adapter: EntityAdapter<TenNeighborhood> = createEntityAdapter<TenNeighborhood>({});

export type NeighborhoodsState = EntityStateModel<TenNeighborhood, TenNeighborhoodSearchParams>;

export const initialState: NeighborhoodsState = adapter.getInitialState({
    listLoading: 'listLoading',
    pagination: {},
    itemsLoading: [],
    filter: {
        sort: "LAST_NAME"
    }
});

export const neighborhoodsReducer = createReducer(
    initialState,

    on(NeighborhoodsActions.CheckState, (state, action) => {
        return adapter.setAll(action.payload.items, {
            ...state,
            pagination: {...state.pagination, number: 0},
            componentOpened: false
        });
    }),

    on(NeighborhoodsActions.LoadList, (state, action) => ({
        ...state,
        listLoading: StoredComponentHelperService.updateListLoading(action.payload, state.ids)
    })),

    on(NeighborhoodsActions.LoadListSuccess, (state, action) => {
        return action.payload.clearState
            ? adapter.setAll(action.payload.items, {
                ...state,
                pagination: action.payload.pagination,
                listLoading: undefined
            })
            : adapter.upsertMany(action.payload.items, {
                ...state,
                pagination: action.payload.pagination,
                listLoading: undefined
            });
    }),

    on(NeighborhoodsActions.LoadListFailure, (state) => ({
        ...state,
        listLoading: undefined
    })),

    on(NeighborhoodsActions.SetFilter, (state, action) => ({
        ...state,
        filter: action.payload
    })),

    on(NeighborhoodsActions.SetPagination, (state, action) => ({
        ...state,
        pagination: {...state.pagination, number: action.payload ? StoredComponentHelperService.setNextPage(state.pagination, state.ids?.length) : 0}
    })),

    on(NeighborhoodsActions.SetLoading, (state, action) => ({
        ...state,
        listLoading: action.payload
    })),

    on(NeighborhoodsActions.SetItemsLoading, (state, action) => ({
        ...state,
        itemsLoading: StoredComponentHelperService.updateItemLoading(state.itemsLoading, action.payload.id, action.payload.isStart)
    })),

    on(NeighborhoodsActions.SetInitialState, SetAllInitialStates, () => ({...initialState}))
);

export const {selectAll: selectAllEntities} = adapter.getSelectors();
